import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxsModule } from '@ngxs/store';

import { NewsAdminState } from './store/states/news-admin.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([NewsAdminState])],
})
export class NewsAdminDataAccessModule {}
